module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMzczOTQ0Ij4KICA8cGF0aAogICAgZD0iTTIwMC04MHEtMzMgMC01Ni41LTIzLjVUMTIwLTE2MHYtNDUxcS0xOC0xMS0yOS0yOC41VDgwLTY4MHYtMTIwcTAtMzMgMjMuNS01Ni41VDE2MC04ODBoNjQwcTMzIDAgNTYuNSAyMy41VDg4MC04MDB2MTIwcTAgMjMtMTEgNDAuNVQ4NDAtNjExdjQ1MXEwIDMzLTIzLjUgNTYuNVQ3NjAtODBIMjAwWm0wLTUyMHY0NDBoNTYwdi00NDBIMjAwWm0tNDAtODBoNjQwdi0xMjBIMTYwdjEyMFptMjAwIDI4MGgyNDB2LTgwSDM2MHY4MFptMTIwIDIwWiIgLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_inventory.svg
// module id = qPCm
// module chunks = 1